// extracted by mini-css-extract-plugin
export default {"container":"SummaryTab_container__HFjkl"};